<div class="how-to-play bg-black/60 fixed top-0 left-0 bottom-0 right-0 z-50  flex items-center justify-center z-1000"
id="howToPlay"
(click)="close.emit()"
>
  <div class="w-full max-w-[1200px] flex flex-col items-center justify-center relative min-h-full">
    <div class="flex flex-col items-center w-full max-w-3xl px-6 sm:px-unset pb-[100px]">
      <div
        class="w-full  max-w-[560px] text-center uppercase bg-black/50 px-4 py-2 md:px-8 md:py-4 font-medium text-white text-[22px]/[110%] md:text-4xl/[110%] rounded-lg mb-6 sm:mb-8 md:mb-10 shrink-0"
      >
        Как играть
      </div>

      <div
        class="w-full max-w-[560px] bg-black/50 p-2 sm:p-4 md:px-8 md:py-4 font-medium text-white text-base/[130%] md:text-[22px]/[130%] rounded-lg mb-6 shrink-0 text-center"
      >
          
        <div class="flex items-center mb-3 gap-5 md:gap-10">
          <img
            src="./assets-compressed/categories/resume/id.png"
            alt=""
            class="size-[50px] md:size-[70px] shrink-0"
          />

          <p class="text-[16px]/[100%] text-left font-normal md:text-[24px]/[120%]">
            Нажми на карьерный id,<br>чтобы&nbsp;открыть
          </p>
        </div>

        <div class="flex items-center mb-3 gap-5 md:gap-10">
          <img
            src="./assets-compressed/categories/icons/step2.png"
            alt=""
            class=" w-[50px] md:w-[70px]  shrink-0  relative top-[5px] left-[5px]"
          />

          <p class="text-[16px]/[100%] text-left font-normal md:text-[24px]/[120%]">
            Нажми на персонажа, чтобы&nbsp;посетить&nbsp;аттракцион
          </p>
        </div>

        <div class="flex items-center mb-3 gap-5 md:gap-10">
          <img
            src="./assets-compressed/categories/icons/step1.png"
            alt=""
            class=" h-[55px] md:h-[70px]  -ml-[8px] -mr-[12px] shrink-0 "
          />

          <p class="text-[16px]/[100%] text-left font-normal md:text-[24px]/[120%]">
            Нажми на дорогу,<br>чтобы&nbsp;идти.
          </p>
        </div>

      </div>
    </div>

    <app-comment class="absolute left-1/2 transform -translate-x-1/2 bottom-8 md:bottom-16" ><span >Нажми,&nbsp;чтобы&nbsp;продолжить</span></app-comment>
  </div>
</div>